<script setup>
import { defineProps, defineEmits, computed} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) => {

    emits('update:alteraDado',update);

};

//==================================================================//
//============= Desativa Cliente - Pedido de Compra ================//
//==================================================================//

const desativaClientePedidoDeCompra = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//================ Desativa Cliente - Email XML ====================//
//==================================================================//

const desativaClienteEmailXML = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//============ Ao Preencher Cliente Pedido de Compra  ==============//
//==================================================================//

const aoPreencherClientePedidoDeCompra = (clientePedidoDeCompra) => {

    alteraDado({
        clientePedidoDeCompra: clientePedidoDeCompra
    });
    
};

//==================================================================//
//================ Ao Preencher Cliente Email XML ==================//
//==================================================================//

const aoPreencherClienteEmailXML = (clienteEmailXML) => {

    alteraDado({
        clienteEmailXML: clienteEmailXML
    });
    
};

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Cliente

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-text-field class="c-campo__input"
                    label="Cliente"
                    :value="props?.dado?.cliente?.nomeFantasia"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

            <div class="c-conjunto-de-campos">

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Cliente - Pedido de Compra"
                        :value="props?.dado?.clientePedidoDeCompra"
                        :disabled="desativaClientePedidoDeCompra"
                        outlined
                        return-object
                        @input="aoPreencherClientePedidoDeCompra"
                    ></v-text-field>

                </div>

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Cliente - Email XML"
                        :value="props?.dado?.clienteEmailXML"
                        :disabled="desativaClienteEmailXML"
                        outlined
                        return-object
                        @input="aoPreencherClienteEmailXML"
                    ></v-text-field>

                </div>

            </div>

            <div class="c-conjunto-de-campos">

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Contato Comercial"
                        :value="props?.dado?.solicitacaoDeOrcamento?.contatoComercial?.nome"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-campo">

                    <v-text-field class="c-campo__input"
                        label="Contrato Técnico"
                        :value="props?.dado?.solicitacaoDeOrcamento?.contatoTecnico?.nome"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 0px 20px;
}

</style>